import { render, staticRenderFns } from "./BankPayment.vue?vue&type=template&id=574f1afd&scoped=true&"
import script from "./BankPayment.vue?vue&type=script&lang=js&"
export * from "./BankPayment.vue?vue&type=script&lang=js&"
import style0 from "./BankPayment.vue?vue&type=style&index=0&id=574f1afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f1afd",
  null
  
)

export default component.exports